import { Crown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const PremiumBadge = ({ className, label = "Premium" }: { className?: string; label?: string }) => (
  <Badge
    className={cn(
      "border-0 bg-gradient-to-r from-amber-400 to-orange-500 text-white shadow-md inline-flex items-center gap-1",
      className,
    )}
  >
    <Crown className="h-3 w-3" />
    {label}
  </Badge>
);
